import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=68dbac84&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ebenhafkamp/Documents/Projects/tacpro/src/webpack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68dbac84')) {
      api.createRecord('68dbac84', component.options)
    } else {
      api.reload('68dbac84', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=68dbac84&", function () {
      api.rerender('68dbac84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/Tab.vue"
export default component.exports